var map = {
	"./chips1.webp": "e5c1",
	"./chips10.webp": "d53a",
	"./chips100.webp": "7437",
	"./chips1000.webp": "45bf",
	"./chips10000.webp": "3b91",
	"./chips100000.webp": "e78b",
	"./chips2.webp": "7047",
	"./chips20.webp": "eb1c",
	"./chips200.webp": "3c22",
	"./chips2000.webp": "ba18",
	"./chips20000.webp": "168c",
	"./chips200000.webp": "1beb",
	"./chips5.webp": "972d",
	"./chips50.webp": "8902",
	"./chips500.webp": "b198",
	"./chips5000.webp": "05f9",
	"./chips50000.webp": "310a",
	"./chips_seting_btn.webp": "d67d",
	"./chipsc.webp": "2cbb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9d7";